var _Path, _Circle, _TSpan;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Circle, Text, TSpan } from "react-native-svg";

function SvgHrNotfound(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 32,
    height: 27,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    fill: "none",
    fillRule: "evenodd"
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M19.573 7c-3.056 0-6.027 3.317-6.027 3.317S10.574 7 7.518 7c-3.056 0-5.973 1.382-5.973 5.454 0 2.89 3 5.429 3 5.429l9 8.117 9-8.117s3-2.54 3-5.43C25.545 8.384 22.63 7 19.573 7z",
    stroke: "#FFF",
    strokeWidth: 1.095
  })), /*#__PURE__*/React.createElement(G, {
    transform: "translate(19)"
  }, _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    fill: "#FFF",
    cx: 6.5,
    cy: 6.5,
    r: 6.5
  })), /*#__PURE__*/React.createElement(Text, {
    fontFamily: "Barlow-Bold, Barlow",
    fontSize: 10.105,
    fontWeight: "bold",
    fill: props.fill
  }, _TSpan || (_TSpan = /*#__PURE__*/React.createElement(TSpan, {
    x: 4.752,
    y: 10
  }, "!"))))));
}

export default SvgHrNotfound;